export default __webpack_public_path__ + "static/media/large_van.1a3287f5.svg";